// Makes requests to CryptoCompare API
export async function makeApiRequest(path) {
  try {
    const response = await fetch(`https://be.gudangkripto.id/${path}`, {
      // const response = await fetch(`https://wscoin.gudangkripto.id/${path}`, {
      // const response = await fetch(`http://localhost:11106/${path}`, {
    });
    return response.json();
  } catch (error) {
    throw new Error(`GudangKripto request error: ${error.status}`);
  }
}

// export async function makeApiRequestCompare(path) {
//   try {
//       const response = await fetch(`https://min-api.cryptocompare.com/data/v2/${path}&api_key=f3da5f7da43212dd832c75ee57b9af9330f9650cf2fac8d3d57a3a222015e119`, {
//       // const response = await fetch(`http://localhost:11106/${path}`, {
//         mode: 'cors',
//         headers: {
//           'Access-Control-Allow-Origin':'*'
//         }
//       });
//       return response.json();
//   } catch(error) {
//       throw new Error(`GudangKripto request error: ${error.status}`);
//   }
// }

// Generates a symbol ID from a pair of the coins
export function generateSymbol(exchange, fromSymbol, toSymbol) {
  const symbol = `${fromSymbol}${toSymbol}`;
  const short = `${fromSymbol}/${toSymbol}`;
  return {
    symbol,
    short,
    full: `${exchange}:${short}`,
  };
}

// Returns all parts of the symbol
export function parseFullSymbol(fullSymbol) {
  const match = fullSymbol.match(/^(\w+):(\w+)\/(\w+)$/);
  if (!match) {
    return null;
  }
  return { exchange: match[1], fromSymbol: match[2], toSymbol: match[3] };
}